import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "http://localhost:8080/api";

/**
 * Logs in the user and saves the JWT to localStorage.
 */
export const login = async (email, password) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/auth/login`, { email, password });
    const token = response.data.token;
    if (token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('twitter_token', response.data.twitterToken);
      localStorage.setItem('userType', response.data.userType);
    } else {
      throw new Error("Token not found in login response");
    }
    return response.data;
  } catch (error) {
    console.error("LOGIN FAILED:", error);
    throw error;
  }
};

export const handleOauthRedirect = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const twitterToken = params.get('twitter_token');

    if (token) {
        localStorage.setItem('token', token);
    }
    if (twitterToken) {
        localStorage.setItem('twitter_token', twitterToken);
    }
    // Also check for userType, if your backend sends it
    const userType = params.get('userType');
    if (userType) {
        localStorage.setItem('userType', userType);
    }
    
    return token; // Return the main token if found
};




export const getToken = () => localStorage.getItem("token");

/**
 * Authenticated Axios instance
 */
const axiosAuth = axios.create({
  baseURL: API_BASE_URL,
});

// Attach token automatically
axiosAuth.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * API functions
 */
const getConnectedAccounts = (user_id) => axiosAuth.post(`/accounts/connected`, { user_id });
const removeAccount = (platform, token , userId) => axiosAuth.delete(`/accounts/disconnect/${platform}`, {
data: { token, userId },
});

/**
 * Export one single object
 */
const accountService = {
  login,
  getConnectedAccounts,
  removeAccount,
handleOauthRedirect,
};

export default accountService;
